<template>
  <!--//@*/*
    //    *BCS   App v0.91
    //    * Copyright (c) 2024, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
  <!-- <timeout
    :seconds_to_warn="600"
    :seconds_to_final="60"
    v-bind:loginURL="loginURL"
    v-if="showtimeout"
  ></timeout> -->
  <div></div>
</template>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
// import timeout from "./timeout";
export default {
  name: "auth",
  mixins: [bus_common],
  components: {},
  data() {
    return {
      x: "auth this",
      refreshTimer: null,
      showtimeout: false,
      /*             loginURL: 'https://rpdlogin.org/rpdauth1/?returnURL=http://localhost:5000/'*/
      loginURL: "https://rpdportal.org?returnURL=https://swat.renopd.com/",
    };
  },
  mounted() {
    return true;
    let callback = () => {
      window.location.replace(self.loginURL);
      // alert("redirect");
    };
    this.showtimeout = true;
    var self = this;
    this.refreshTimer = window.setTimeout(() => {
      if (
        self.$store.state.user.token != undefined &&
        self.$store.state.user.auth == true
      ) {
        var form = { token: this.$store.state.user.token };

        this.$store
          .dispatch("valtoken", form)
          .then((data) => {
            console.log("Valid");
            var user = {
              email: data.email,
              date: this.$moment(data.date),
              auth: true,
              token: data.token,
              roles: data.roles,
              rpduserId: data.rpduserId,
              local_roleId: data.local_roleId,
            };

            this.$store.commit("setUser", user);
          })
          .catch((error) => {
            if (error.response) {
              self.show_loader(false);
              this.$swal({
                title: "Login Error!",
                text: "You have not logged in or your login has timed out, you will be redirected to the login page.",
                icon: "warning",
                confirmButtonText: "OK",
                confirmButtonColor: "#283593",
                timer: 3000,
                didClose: callback,
              });
            }
          });
      }
    }, 300000);
    //Check token evey 5m
  },
  created() {
    setTimeout(() => {
      console.log("auth created");
      let callback = () => {
        window.location.replace(self.loginURL);
        //  alert("redirect");
      };
      var qry_token = this.$route.query.token;
      var user_token = this.$store.state.user.token;
      var self = this;
      console.log("user token: " + user_token);
      console.log("query token: " + qry_token);

      if (qry_token == undefined && user_token == "") {
        var self = this;
        self.show_loader(false);
        this.$swal({
          title: "Login Not Found!",
          text: "You have not logged in or your login has timed out, you will be redirected to the login page.",
          icon: "warning",
          confirmButtonText: "OK",
          confirmButtonColor: "#283593",
          timer: 3000,
          didClose: callback,
        });
      } else {
        //validate toke, query takes precendent
        var token = qry_token != undefined ? qry_token : user_token;

        var form = {
          token: token,
        };

        var self = this;
        /*                this.$axios.post('api/valtoken', form)*/
        this.$store
          .dispatch("valtoken", form)
          .then((data) => {
            console.log("valid");
            var user = {
              email: data.email,
              date: this.$moment(data.date),
              auth: true,
              token: token,
              roles: data.roles,
              rpduserId: data.rpduserId,
              local_roleId: data.local_roleId,
            };

            this.$store.commit("setUser", user);

            if (user.roles.indexOf("swat-login") == -1) {
              self.show_loader(false);
              this.$swal({
                title: "Login Error!",
                text: "You do no have the needed role to use this app.",
                icon: "warning",
                confirmButtonText: "OK",
                confirmButtonColor: "#283593",
                timer: 3000,
                didClose: callback,
              });
            }
          })
          .catch((error) => {
            if (error.response) {
              self.show_loader(false);
              this.$swal({
                title: "Login Not Found!",
                text: "You have not logged in or your login has timed out, you will be redirected to the login page.",
                icon: "error",
                confirmButtonText: "OK",
                confirmButtonColor: "#283593",
                timer: 3000,
                didClose: callback,
              });
            }
          });
      }
    }, 500);
  },
};
</script>
